/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslatableType = exports.Sort = exports.ServiceAppendixType = exports.SegmentSegment = exports.PermissionType = exports.PagingType = exports.OptimizeMode = exports.Operator = exports.Method = exports.MessageAppendixType = exports.Maturity = exports.Label = exports.JSType = exports.IdempotencyLevel = exports.HttpStatusCode = exports.Format = exports.FieldDescriptorProtoType = exports.Exposure = exports.EventType = exports.CType = void 0;
var CType;
(function (CType) {
    CType["STRING"] = "STRING";
    CType["CORD"] = "CORD";
    CType["STRING_PIECE"] = "STRING_PIECE";
})(CType = exports.CType || (exports.CType = {}));
var EventType;
(function (EventType) {
    EventType["UNKNOWN"] = "UNKNOWN";
    EventType["CREATED"] = "CREATED";
    EventType["UPDATED"] = "UPDATED";
    EventType["DELETED"] = "DELETED";
    EventType["ACTION"] = "ACTION";
})(EventType = exports.EventType || (exports.EventType = {}));
var Exposure;
(function (Exposure) {
    Exposure["PRIVATE"] = "PRIVATE";
    Exposure["INTERNAL"] = "INTERNAL";
    Exposure["PUBLIC"] = "PUBLIC";
})(Exposure = exports.Exposure || (exports.Exposure = {}));
var FieldDescriptorProtoType;
(function (FieldDescriptorProtoType) {
    FieldDescriptorProtoType["TYPE_DOUBLE"] = "TYPE_DOUBLE";
    FieldDescriptorProtoType["TYPE_FLOAT"] = "TYPE_FLOAT";
    FieldDescriptorProtoType["TYPE_INT64"] = "TYPE_INT64";
    FieldDescriptorProtoType["TYPE_UINT64"] = "TYPE_UINT64";
    FieldDescriptorProtoType["TYPE_INT32"] = "TYPE_INT32";
    FieldDescriptorProtoType["TYPE_FIXED64"] = "TYPE_FIXED64";
    FieldDescriptorProtoType["TYPE_FIXED32"] = "TYPE_FIXED32";
    FieldDescriptorProtoType["TYPE_BOOL"] = "TYPE_BOOL";
    FieldDescriptorProtoType["TYPE_STRING"] = "TYPE_STRING";
    FieldDescriptorProtoType["TYPE_GROUP"] = "TYPE_GROUP";
    FieldDescriptorProtoType["TYPE_MESSAGE"] = "TYPE_MESSAGE";
    FieldDescriptorProtoType["TYPE_BYTES"] = "TYPE_BYTES";
    FieldDescriptorProtoType["TYPE_UINT32"] = "TYPE_UINT32";
    FieldDescriptorProtoType["TYPE_ENUM"] = "TYPE_ENUM";
    FieldDescriptorProtoType["TYPE_SFIXED32"] = "TYPE_SFIXED32";
    FieldDescriptorProtoType["TYPE_SFIXED64"] = "TYPE_SFIXED64";
    FieldDescriptorProtoType["TYPE_SINT32"] = "TYPE_SINT32";
    FieldDescriptorProtoType["TYPE_SINT64"] = "TYPE_SINT64";
})(FieldDescriptorProtoType = exports.FieldDescriptorProtoType || (exports.FieldDescriptorProtoType = {}));
var Format;
(function (Format) {
    Format["EMAIL"] = "EMAIL";
    Format["HOSTNAME"] = "HOSTNAME";
    Format["IPV4"] = "IPV4";
    Format["IPV6"] = "IPV6";
    Format["URI"] = "URI";
    Format["WEB_URL"] = "WEB_URL";
    Format["PHONE"] = "PHONE";
    Format["CREDIT_CARD"] = "CREDIT_CARD";
    Format["GUID"] = "GUID";
    Format["COUNTRY"] = "COUNTRY";
    Format["LANGUAGE"] = "LANGUAGE";
    Format["DECIMAL_VALUE"] = "DECIMAL_VALUE";
    Format["CURRENCY"] = "CURRENCY";
    Format["LANGUAGE_TAG"] = "LANGUAGE_TAG";
    Format["COLOR_HEX"] = "COLOR_HEX";
    Format["LOCAL_DATE"] = "LOCAL_DATE";
    Format["LOCAL_TIME"] = "LOCAL_TIME";
    Format["LOCAL_DATE_TIME"] = "LOCAL_DATE_TIME";
})(Format = exports.Format || (exports.Format = {}));
var HttpStatusCode;
(function (HttpStatusCode) {
    HttpStatusCode["OK"] = "OK";
    HttpStatusCode["UNAUTHENTICATED"] = "UNAUTHENTICATED";
    HttpStatusCode["PERMISSION_DENIED"] = "PERMISSION_DENIED";
    HttpStatusCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    HttpStatusCode["NOT_FOUND"] = "NOT_FOUND";
    HttpStatusCode["INTERNAL"] = "INTERNAL";
    HttpStatusCode["UNAVAILABLE"] = "UNAVAILABLE";
    HttpStatusCode["RESOURCE_EXHAUSTED"] = "RESOURCE_EXHAUSTED";
    HttpStatusCode["CANCELED"] = "CANCELED";
    HttpStatusCode["ALREADY_EXISTS"] = "ALREADY_EXISTS";
    HttpStatusCode["FAILED_PRECONDITION"] = "FAILED_PRECONDITION";
})(HttpStatusCode = exports.HttpStatusCode || (exports.HttpStatusCode = {}));
var IdempotencyLevel;
(function (IdempotencyLevel) {
    IdempotencyLevel["IDEMPOTENCY_UNKNOWN"] = "IDEMPOTENCY_UNKNOWN";
    IdempotencyLevel["NO_SIDE_EFFECTS"] = "NO_SIDE_EFFECTS";
    IdempotencyLevel["IDEMPOTENT"] = "IDEMPOTENT";
})(IdempotencyLevel = exports.IdempotencyLevel || (exports.IdempotencyLevel = {}));
var JSType;
(function (JSType) {
    JSType["JS_NORMAL"] = "JS_NORMAL";
    JSType["JS_STRING"] = "JS_STRING";
    JSType["JS_NUMBER"] = "JS_NUMBER";
})(JSType = exports.JSType || (exports.JSType = {}));
var Label;
(function (Label) {
    Label["LABEL_OPTIONAL"] = "LABEL_OPTIONAL";
    Label["LABEL_REQUIRED"] = "LABEL_REQUIRED";
    Label["LABEL_REPEATED"] = "LABEL_REPEATED";
})(Label = exports.Label || (exports.Label = {}));
var Maturity;
(function (Maturity) {
    Maturity["ALPHA"] = "ALPHA";
    Maturity["BETA"] = "BETA";
    Maturity["IA"] = "IA";
    Maturity["GA"] = "GA";
    Maturity["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
})(Maturity = exports.Maturity || (exports.Maturity = {}));
var MessageAppendixType;
(function (MessageAppendixType) {
    MessageAppendixType["UNKNOWN_APPENDIX_TYPE"] = "UNKNOWN_APPENDIX_TYPE";
    MessageAppendixType["AUTO_VELO"] = "AUTO_VELO";
    MessageAppendixType["DOCS_CONF"] = "DOCS_CONF";
    MessageAppendixType["MULTILINGUAL"] = "MULTILINGUAL";
})(MessageAppendixType = exports.MessageAppendixType || (exports.MessageAppendixType = {}));
var Method;
(function (Method) {
    Method["UNKNOWN_METHOD"] = "UNKNOWN_METHOD";
    Method["CREATE"] = "CREATE";
    Method["GET_ITEM"] = "GET_ITEM";
    Method["UPDATE"] = "UPDATE";
    Method["DELETE"] = "DELETE";
    Method["UPSERT"] = "UPSERT";
    Method["LIST"] = "LIST";
    Method["QUERY"] = "QUERY";
    Method["SEARCH"] = "SEARCH";
    Method["BULK_CREATE"] = "BULK_CREATE";
    Method["BULK_UPDATE"] = "BULK_UPDATE";
    Method["BULK_UPDATE_BY_FILTER"] = "BULK_UPDATE_BY_FILTER";
    Method["BULK_DELETE"] = "BULK_DELETE";
    Method["BULK_DELETE_BY_FILTER"] = "BULK_DELETE_BY_FILTER";
    Method["BULK_UPSERT"] = "BULK_UPSERT";
    Method["LIST_DELETED"] = "LIST_DELETED";
    Method["GET_DELETED"] = "GET_DELETED";
    Method["RESTORE_FROM_TRASHBIN"] = "RESTORE_FROM_TRASHBIN";
    Method["REMOVE_FROM_TRASHBIN"] = "REMOVE_FROM_TRASHBIN";
})(Method = exports.Method || (exports.Method = {}));
var Operator;
(function (Operator) {
    Operator["ALL_APPLICABLE_OPERATORS"] = "ALL_APPLICABLE_OPERATORS";
    Operator["EQ"] = "EQ";
    Operator["GT"] = "GT";
    Operator["GTE"] = "GTE";
    Operator["IN"] = "IN";
    Operator["LT"] = "LT";
    Operator["LTE"] = "LTE";
    Operator["NE"] = "NE";
    Operator["NIN"] = "NIN";
    Operator["BEGINS"] = "BEGINS";
    Operator["EXISTS"] = "EXISTS";
    Operator["ALL"] = "ALL";
    Operator["ANY"] = "ANY";
    Operator["EMPTY"] = "EMPTY";
})(Operator = exports.Operator || (exports.Operator = {}));
var OptimizeMode;
(function (OptimizeMode) {
    OptimizeMode["SPEED"] = "SPEED";
    OptimizeMode["CODE_SIZE"] = "CODE_SIZE";
    OptimizeMode["LITE_RUNTIME"] = "LITE_RUNTIME";
})(OptimizeMode = exports.OptimizeMode || (exports.OptimizeMode = {}));
var PagingType;
(function (PagingType) {
    PagingType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    PagingType["OFFSET"] = "OFFSET";
    PagingType["CURSOR"] = "CURSOR";
})(PagingType = exports.PagingType || (exports.PagingType = {}));
var PermissionType;
(function (PermissionType) {
    PermissionType["AUTO"] = "AUTO";
    PermissionType["MANUAL"] = "MANUAL";
})(PermissionType = exports.PermissionType || (exports.PermissionType = {}));
var SegmentSegment;
(function (SegmentSegment) {
    SegmentSegment["UNSPECIFIED"] = "UNSPECIFIED";
    SegmentSegment["USERS"] = "USERS";
    SegmentSegment["PUBLIC"] = "PUBLIC";
    SegmentSegment["OTHERS"] = "OTHERS";
})(SegmentSegment = exports.SegmentSegment || (exports.SegmentSegment = {}));
var ServiceAppendixType;
(function (ServiceAppendixType) {
    ServiceAppendixType["UNKNOWN_APPENDIX_TYPE"] = "UNKNOWN_APPENDIX_TYPE";
    ServiceAppendixType["NILE"] = "NILE";
    ServiceAppendixType["MESSAGE_BUS"] = "MESSAGE_BUS";
})(ServiceAppendixType = exports.ServiceAppendixType || (exports.ServiceAppendixType = {}));
var Sort;
(function (Sort) {
    Sort["NONE"] = "NONE";
    Sort["ASC"] = "ASC";
    Sort["DESC"] = "DESC";
    Sort["BOTH"] = "BOTH";
})(Sort = exports.Sort || (exports.Sort = {}));
var TranslatableType;
(function (TranslatableType) {
    TranslatableType["UNDEFINED_TYPE"] = "UNDEFINED_TYPE";
    TranslatableType["SHORT_TEXT"] = "SHORT_TEXT";
    TranslatableType["LONG_TEXT"] = "LONG_TEXT";
    TranslatableType["RICH_TEXT"] = "RICH_TEXT";
    TranslatableType["RICH_CONTENT_EDITOR"] = "RICH_CONTENT_EDITOR";
    TranslatableType["SELECTION"] = "SELECTION";
    TranslatableType["MULTI_SELECTION"] = "MULTI_SELECTION";
    TranslatableType["DOCUMENT"] = "DOCUMENT";
    TranslatableType["IMAGE"] = "IMAGE";
    TranslatableType["VIDEO"] = "VIDEO";
})(TranslatableType = exports.TranslatableType || (exports.TranslatableType = {}));
//# sourceMappingURL=types.js.map